import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const TECH = [
  "REACT",
  "FASTAPI",
  "MONGODB",
  "CLAUDE 4.5",
  "GPT-5",
  "GEMINI 3",
  "AWS",
  "DOCKER",
  "TYPESCRIPT",
  "PYTHON",
  "KUBERNETES",
  "NEXT.JS",
  "STRIPE",
  "TAILWIND",
];

export const TechMarquee = () => {
  return (
    <section
      data-testid="tech-marquee"
      className="relative py-10 border-b border-white/10 bg-black overflow-hidden"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="marquee-fade"
      >
        <Marquee gradient={false} speed={40} pauseOnHover>
          {TECH.map((t, i) => (
            <div
              key={i}
              className="mx-8 flex items-center gap-3 font-mono-x text-xs tracking-[0.3em] uppercase text-slate-500 hover:text-brand-500 transition-colors duration-200"
            >
              <span className="w-1 h-1 bg-brand-500" />
              {t}
            </div>
          ))}
        </Marquee>
      </motion.div>
    </section>
  );
};
